import { t } from '../i18n';
import { escapeHtml } from '../utils/html';
import { FACILITY_CATEGORIES } from '../services/facilityService';

/**
 * 🏢 Corporate pack — the visitor-facing 🛠 report sheet (bottom card, same
 * pattern as the capture review sheet). Collects category + note + optional
 * reporter name and whether to attach a photo; main.ts owns the actual
 * submit (photo capture + service call + toast).
 */
export interface FacilityReportDraft {
  category: string;
  note: string;
  reporter: string;
  withPhoto: boolean;
}

export class FacilityReportSheet {
  readonly el: HTMLDivElement;
  private onDone: ((draft: FacilityReportDraft | null) => void) | null = null;

  constructor() {
    this.el = document.createElement('div');
    this.el.className = 'sheet facility-sheet hidden';
    this.el.innerHTML = `
      <h2>${escapeHtml(t('fac.title'))}</h2>
      <p class="sheet-subtitle facility-near hidden"></p>
      <label class="sheet-label">${escapeHtml(t('fac.category'))}</label>
      <select class="facility-cat">${FACILITY_CATEGORIES.map((c) => `<option>${escapeHtml(c)}</option>`).join('')}</select>
      <textarea class="facility-note" rows="3" placeholder="${escapeHtml(t('fac.notePh'))}"></textarea>
      <input class="facility-name" type="text" placeholder="${escapeHtml(t('fac.namePh'))}" />
      <label class="sheet-toggle"><input type="checkbox" class="facility-photo" checked /> ${escapeHtml(t('fac.photo'))}</label>
      <div class="sheet-btns">
        <button class="btn primary facility-send">${escapeHtml(t('fac.submit'))}</button>
        <button class="btn ghost facility-cancel">${escapeHtml(t('common.cancel'))}</button>
      </div>`;
    (this.el.querySelector('.facility-send') as HTMLButtonElement).addEventListener('click', () => {
      const draft: FacilityReportDraft = {
        category: (this.el.querySelector('.facility-cat') as HTMLSelectElement).value,
        note: (this.el.querySelector('.facility-note') as HTMLTextAreaElement).value.trim(),
        reporter: (this.el.querySelector('.facility-name') as HTMLInputElement).value.trim(),
        withPhoto: (this.el.querySelector('.facility-photo') as HTMLInputElement).checked,
      };
      this.finish(draft);
    });
    (this.el.querySelector('.facility-cancel') as HTMLButtonElement).addEventListener('click', () =>
      this.finish(null),
    );
  }

  get visible(): boolean {
    return !this.el.classList.contains('hidden');
  }

  show(nearPoiName: string | null, onDone: (draft: FacilityReportDraft | null) => void): void {
    this.onDone = onDone;
    const near = this.el.querySelector('.facility-near') as HTMLElement;
    if (nearPoiName) {
      near.textContent = t('fac.near', { name: nearPoiName });
      near.classList.remove('hidden');
    } else {
      near.classList.add('hidden');
    }
    (this.el.querySelector('.facility-note') as HTMLTextAreaElement).value = '';
    this.el.classList.remove('hidden');
  }

  private finish(draft: FacilityReportDraft | null): void {
    this.el.classList.add('hidden');
    const cb = this.onDone;
    this.onDone = null;
    cb?.(draft);
  }
}
